import React, { useEffect, useState } from 'react';
import LayouthInfoUko from '../../../components/AuthenticationLayoutUko/LayouthInfoUko';
import { CHECKEMAIL, ERRORINFO, PASSWORDUPDATED, SENDEMAIL, ACCOUNTACTIVATED } from '../../../actions/auth.action.entry';
import ShowAlertUko from "../../../components/alertUko.component";
import { useTheme } from '@material-ui/core';
import SuccessAlertUko from './SuccessAlertUko';
import { enmaskEmail } from '../../../utils/utils';
import { connect } from 'react-redux';

const InfoUko = (props) => {

    const {
        appName,
        history,
        tenant,
        userList,
    } = props;

    const CHECKEMAILAGAIN = 'CHECK_EMAIL_AGAIN';
    const INVALIDLINK = 'INVALID_LINK';

    const theme = useTheme();
    const [messageTypeFromHistory, setmessageTypeFromHistory] = useState(history.location.state?.messageType);
    const [messageCheckEmail, setmessageCheckEmail] = useState("");
    const [countdown, setCountdown] = useState(-1);

    const setMessage = (email) => {
        return <div> <center>Te hemos enviado un email a <b>{email}</b>, ve allí para <br />
            continuar con el proceso. No olvides revisar el spam. </center> </div>;
    }

    const handleClick = () => {
        if (history) {
            if (history.location.state.pagename && history.location.state.pagename !== "") {
                window.location.replace(history.location.state.pagename);
            }
        }
    }

    const onClickLinkEmail = () => {
        setmessageTypeFromHistory(CHECKEMAILAGAIN);
        setCountdown(60);
    }

    /**
     * Extract new message with current email from history
     * Remember: history is updated eith backend services
     */
    useEffect(() => {
        const userEmail = history.location.state?.emailFromUser;
        switch (messageTypeFromHistory) {
            case INVALIDLINK:
                setmessageCheckEmail(<div> <center>El tiempo para activar tu cuenta ha finalizado,
                    hemos enviado a tu <br /> email un nuevo vínculo de activación. </center> </div>);
                break;
            case CHECKEMAILAGAIN:
                setmessageCheckEmail(<div> <center>Te hemos reenviado un email a <b>{enmaskEmail(userEmail)}</b><br />
                    No olvides revisar el spam. </center> </div>);
                break;
            default:
                setmessageCheckEmail(<div> <center>Te hemos enviado un email a <b>{enmaskEmail(userEmail)}</b><br />
                    No olvides revisar el spam. </center> </div>);
                break;
        }
    }, [messageTypeFromHistory, history])

    useEffect(() => {
      const userEmail = history.location.state?.maskedEmail;  
      if (userEmail) {
          setmessageTypeFromHistory(CHECKEMAIL);
      }
    }, [userList, history]);
    


    useEffect(() => {
        if (countdown > 0) {
            setTimeout(
                () => setCountdown(countdown - 1),
                1000
            );
        }
    }, [countdown])

    const renderInfo = (messageType) => {
        switch (messageType) {
            case CHECKEMAIL:
                return (
                    <LayouthInfoUko
                        appName={appName}
                        firstImage={theme.urlLogo.urlAlert}
                        title={"¡Revisa tu email!"}
                        secondImage={"urlCheckEmailMoreBlue"}
                        widthOfSecondImage={theme.logoSettings?.heightResendEmail}
                        textBeforeEnd={setMessage(history.location.state.maskedEmail)}
                        tenant={tenant}
                    >
                    </LayouthInfoUko>
                );
            case SENDEMAIL:
                return (
                    <LayouthInfoUko
                        appName={appName}
                        firstImage={"urlSignIn"}
                        title={"¡Este enlace ya no es válido!"}
                        secondImage={"urlExpireTime"}
                        infoText={"Para restablecer tu contraseña ingresa de nuevo tu email"}
                        hasInput={true}
                        widthOfSecondImage={'225px'}
                        tenant={tenant}
                    ></LayouthInfoUko>
                );
            case ERRORINFO:
                return <ShowAlertUko
                    logo={theme.urlLogo.urlAlert}
                    image={{
                        url: theme.alertUko.imageUko,
                        width: theme.logoSettings.heightResendEmail
                    }}
                    value={history.location.state?.message}
                    onClick={handleClick}
                    appName={appName}
                    tenant={tenant}
                />;
            case PASSWORDUPDATED:
                return <SuccessAlertUko type={"PASSWORDUPDATED"}/>;
            case ACCOUNTACTIVATED:
                return <SuccessAlertUko type={"ACCOUNTACTIVATED"}/>;
            case INVALIDLINK:
                return <LayouthInfoUko
                    appName={appName}
                    firstImage={theme.urlLogo.urlSignIn}
                    title={"¡Tiempo de activación finalizado!"}
                    secondImage={"urlExpireTime"}
                    widthOfSecondImage="220px"
                    textBeforeEnd={messageCheckEmail}
                    onClickLink={onClickLinkEmail}
                    textInLink={'¿No has recibido el email?'}
                    tenant={tenant}
                />;
            case CHECKEMAILAGAIN:
                return <LayouthInfoUko
                    appName={appName}
                    firstImage={theme.urlLogo.urlSignIn}
                    title={"¡Revisa de nuevo tu email!"}
                    secondImage={"urlCheckEmailAgain"}
                    textBeforeEnd={messageCheckEmail}
                    textInTheEnd={countdown > 0 ? <div>Intentalo de nuevo en <b>00:{countdown}</b></div> : ''}
                    onClickLink={onClickLinkEmail}
                    textInLink={ countdown === 0 ? '¿No has recibido el email?' : ''}
                    countdown={countdown}
                    setCountdown={setCountdown}
                    tenant={tenant}
                    widthOfSecondImage="274px"
                />;
            default:
                return (
                    <LayouthInfoUko
                        appName={appName}
                        firstImage={theme.urlLogo?.urlResendEmailLogo}
                        title={"¡Este enlace ya no es válido!"}
                        secondImage={"urlInvalidLinkMoreBlue"}
                        infoText={<div><center>Para restablecer tu contraseña ingresa de nuevo tu email.</center></div>}
                        hasInput={true}
                        tenant={tenant}
                        widthOfSecondImage={theme.logoSettings?.heightResendEmail}
                    ></LayouthInfoUko>
                );
        }
    }

    return (
        <div>
            {renderInfo(messageTypeFromHistory)}
        </div>
    );
}

const mapStateToProps = (state) => ({
    userList: state.authReducer.userList,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoUko);

